import Vue from 'vue';
import Vuex from 'vuex';
import * as firebase from 'firebase/app';
import { vuexfireMutations, firestoreAction } from 'vuexfire';
import 'firebase/auth';
import 'firebase/storage';
import 'firebase/firestore';
import * as firebaseui from 'firebaseui';
import {
  COLLECTION_CAMPAIGNADDS,
  COLLECTION_NOTIFICATIONS,
  COLLECTION_ORGANIZATIONS,
  COLLECTION_POSTS,
  COLLECTION_ROLES,
  COLLECTION_USERS,
} from '@/model/AppConstants';
import FirebaseUtil from '@/model/FirebaseUtil';
import AccessType from '@/model/AccessType';
import StatusType from '@/model/typelist/StatusType';
import PostType from '@/model/typelist/PostType';
// import serviceAccount from '@/serviceAdminSDK.json'

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyBSea7UHZip6ZwJTw3cpLl3B885GvHJ8iE',
  authDomain: 'ineed-social.firebaseapp.com',
  databaseURL: 'https://ineed-social.firebaseio.com',
  projectId: 'ineed-social',
  storageBucket: 'ineed-social.appspot.com',
  messagingSenderId: '774375166649',
  appId: '1:774375166649:web:4637ba2da7e659f0b7c168',
  measurementId: 'G-DNJL1HCK9P',
};

firebase.initializeApp(firebaseConfig).firestore();

// Initialize the FirebaseUI Widget using Firebase.
const ui = new firebaseui.auth.AuthUI(firebase.auth());

const uiConfig = {
  signInFlow: 'popup',
  signInOptions: [
    // Leave the lines as is for the providers you want to offer your users.
    firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    firebase.auth.FacebookAuthProvider.PROVIDER_ID,
  ],
  // // Terms of service url.
  // tosUrl: 'https://ineedsocialhub.web.app/',
  // // // Privacy policy url.
  // privacyPolicyUrl: 'https://ineedsocialhub.web.app/',
};

const storage = firebase.storage();
const storageRef = storage.ref();

const db = firebase.firestore();
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentUser: null,
    freshCurrentUser: {},
    firebase,
    ui,
    uiConfig,
    db,
    storageRef,
    homePagePosts: [],
    users: [],
    friends: [],
    friendDetails: [],
    people: [],
    requests: [],
    requestsUsers: [],
    reciveds: [],
    recivedUsers: [],
    dummy: [],
    chatRooms: [],
    WaitingOrganizations: [],
    approvedOrganizations: [],
    orgObj: {},
    roles: [],
    moderators: [],
    campaignAdds: [],
    setRoleObj: {},
    profileUser: {},
    userProfileFriends: [],
    OrgPosts: [],
    orgFollowers: [],
    compaignPosts: [],
    orgMembers: [],
    orgModerationMembers: [],
    rejectPosts: [],
    reportPagePosts: [],
    homePageFollowerPosts: [],
    followingOrgs: [],
    subOrganizations: [],
    postDetail: {},
    fevorateOrgs: [],
    OrgPrivatePosts: [],
    notifications: [],
  },
  mutations: {
    setUser(state, user) {
      state.currentUser = user;
    },
    setOrg(state, org) {
      state.orgObj = org;
    },
    setRecivedUsers(state, user) {
      state.recivedUsers = user;
    },
    setFriendDetails(state, user) {
      state.friendDetails = user;
    },
    setrequests(state, user) {
      state.requestsUsers = user;
    },
    setModEmpty(state, mod) {
      state.moderators = mod;
    },
    setPermissions(state, item) {
      state.setRoleObj = item;
    },
    setUserProfileFrnds(state, item) {
      state.userProfileFriends = item;
    },
    setfreshCurrentUser(state, item) {
      state.freshCurrentUser = item;
    },
    ...vuexfireMutations,
  },
  actions: {
    // eslint-disable-next-line
    bindNotifications: firestoreAction(({ bindFirestoreRef }, item: any) => {
      return new Promise((resolve, reject) => {
        bindFirestoreRef('notifications', db.collection(COLLECTION_NOTIFICATIONS)
          .where('to', '==', FirebaseUtil.ObjectToRef(COLLECTION_USERS, item)))
          .then((result: any) => {
            resolve(result);
          })
          .catch((err: any) => {
            reject(err);
          });
      });
    }),
    // eslint-disable-next-line
    bindPostDetails: firestoreAction(({ bindFirestoreRef }, item: any) => {
      return new Promise((resolve, reject) => {
        bindFirestoreRef('postDetail', db.collection('posts')
          .doc(item))
          .then((result: any) => {
            resolve(result);
          })
          .catch((err: any) => {
            reject(err);
          });
      });
    }),
    // eslint-disable-next-line
    bindOrgObj: firestoreAction(({ bindFirestoreRef }, item: any) => {
      return new Promise((resolve, reject) => {
        bindFirestoreRef('orgObj', db.collection(COLLECTION_ORGANIZATIONS)
          .doc(item))
          .then((result: any) => {
            resolve(result);
          })
          .catch((err: any) => {
            reject(err);
          });
      });
    }),
    // eslint-disable-next-line
    bindFollowingOrgs: firestoreAction(({ bindFirestoreRef }: any, item: any) => {
      return new Promise((resolve, reject) => {
        bindFirestoreRef('followingOrgs', db.collection('organizations')
          .where('followers', 'array-contains', item))
          .then((result: any) => {
            resolve(result);
          })
          .catch((err: any) => {
            reject(err);
          });
      });
    }),
    // eslint-disable-next-line
    bindFevorateOrgs: firestoreAction(({ bindFirestoreRef }, item: any) => {
      return new Promise((resolve, reject) => {
        bindFirestoreRef('fevorateOrgs', db.collection('organizations')
          .where(firebase.firestore.FieldPath.documentId(), 'in', item))
          // .where(, 'in', item))
          .then((result: any) => {
            resolve(result);
          })
          .catch((err: any) => {
            reject(err);
          });
      });
    }),
    // eslint-disable-next-line
    bindcompaignPosts: firestoreAction(({ commit, state, bindFirestoreRef }: any) => {
      return new Promise((resolve, reject) => {
        bindFirestoreRef('compaignPosts', db.collection('posts')
          .where('access.code', '==', AccessType.campaignAddType.code))
          .then((result: any) => {
            resolve(result);
          })
          .catch((err: any) => {
            reject(err);
          });
      });
    }),
    bindCurrentUser: firestoreAction(({ bindFirestoreRef }, item: any) => {
      bindFirestoreRef('freshCurrentUser', db.collection('users').doc(item));
    }),
    bindUserFriends: firestoreAction(({ commit, state, bindFirestoreRef }: any, item: any) => {
      bindFirestoreRef('userProfileFriends', db.collection('users')
        .doc(item)
        .collection('friends'))
        .then((documents: any) => {
          const frnds = [] as any;
          documents.forEach((user: any) => {
            db.collection('users').doc(user.uid)
              .onSnapshot((doc) => {
                frnds.push(doc.data());
              });
          });
          commit('setUserProfileFrnds', frnds);
        });
    }),
    findUserProfile: firestoreAction(({ commit, state, bindFirestoreRef }: any, item: any) => {
      bindFirestoreRef('profileUser', db.collection(COLLECTION_USERS)
        .doc(item));
      // .where('uid', '==', item));
    }),
    bindRole: firestoreAction(({ commit, state, bindFirestoreRef }: any) => {
      bindFirestoreRef(COLLECTION_ROLES, db.collection(COLLECTION_ROLES));
    }),
    bindCampaignAdd: firestoreAction(({ commit, state, bindFirestoreRef }: any) => {
      bindFirestoreRef(COLLECTION_CAMPAIGNADDS, db.collection(COLLECTION_CAMPAIGNADDS));
    }),
    findModerator: firestoreAction(({ commit, state, bindFirestoreRef }: any, item: any) => {
      bindFirestoreRef('moderators', db.collection(COLLECTION_USERS)
        .where('email', '==', item));
    }),
    bindPeople: firestoreAction(({ bindFirestoreRef }) => bindFirestoreRef(
      'people',
      db.collection('users'),
      {
        reset: false,
      },
    )),
    bindWaitingOrganizations: firestoreAction(({ bindFirestoreRef }: any) => {
      bindFirestoreRef('WaitingOrganizations', db.collection(COLLECTION_ORGANIZATIONS)
        .where('status.code', '==', 'waitingForApproval'));
    }),
    bindApprovedOrganizations: firestoreAction(({ bindFirestoreRef }: any) => {
      bindFirestoreRef('approvedOrganizations', db.collection(COLLECTION_ORGANIZATIONS)
        .where('status.code', '==', 'approved')
        .where('subType', '==', null)
        .where('parent', '==', null));
    }),
    bindSubOrganizations: firestoreAction(({ bindFirestoreRef }, item: any) => {
      bindFirestoreRef('subOrganizations', db.collection(COLLECTION_ORGANIZATIONS)
        .where('status.code', '==', 'approved')
        .where(firebase.firestore.FieldPath.documentId(), 'in', item));
    }),
    bindChatRoom: firestoreAction(({ commit, state, bindFirestoreRef }: any) => {
      bindFirestoreRef('chatRooms', db.collection('chatRooms'));
      // .then((documents: any) => {
      //   documents.forEach((doc: any) => {
      //   });
      //   // commit('setrequests', users);
      // });
    }),
    bindRequest: firestoreAction(({ commit, state, bindFirestoreRef }: any) => {
      bindFirestoreRef('requests', db.collection('users')
        .doc(state.currentUser.uid)
        .collection('sendRequests'))
        .then((documents: any) => {
          const users = [] as any;
          documents.forEach((user: any) => {
            db.collection('users').doc(user.uid)
              .onSnapshot((doc) => {
                users.push(doc.data());
              });
          });
          commit('setrequests', users);
        });
    }),
    bindRecived: firestoreAction(({ commit, state, bindFirestoreRef }: any) => {
      bindFirestoreRef('reciveds', db.collection('users')
        .doc(state.currentUser.uid)
        .collection('RecivedRequests'))
        .then((documents: any) => {
          const users = [] as any;
          documents.forEach((user: any) => {
            db.collection('users').doc(user.uid)
              .onSnapshot((doc) => {
                users.push(doc.data());
              });
          });
          commit('setRecivedUsers', users);
        });
    }),
    // eslint-disable-next-line
    bindFriends: firestoreAction(({ commit, state, bindFirestoreRef }: any) => {
      return new Promise((resolve, reject) => {
        bindFirestoreRef('friends', db.collection('users')
          .doc(state.currentUser.uid)
          .collection('friends'))
          .then((documents: any) => {
            const users = [] as any;
            documents.forEach((user: any) => {
              db.collection('users').doc(user.uid)
                .onSnapshot((doc) => {
                  users.push(doc.data());
                });
            });
            commit('setFriendDetails', users);
          }).then((result: any) => {
            resolve(result);
          })
          .catch((err: any) => {
            reject(err);
          });
      });
    }),
    bindOrgPosts: firestoreAction(({ bindFirestoreRef }: any, item: any[]) => {
      bindFirestoreRef('OrgPosts', db.collection('posts')
        .where('organization', '==', item));
    }),
    bindOrgPublicPosts: firestoreAction(({ bindFirestoreRef }: any, item: any[]) => {
      bindFirestoreRef('OrgPosts', db.collection('posts')
        .where('access.code', '==', AccessType.publicType.code)
        .where('organization', '==', item));
    }),
    bindOrgPrivatePosts: firestoreAction(({ bindFirestoreRef }: any, item: any[]) => {
      bindFirestoreRef('OrgPrivatePosts', db.collection('posts')
        .where('access.code', '==', AccessType.privateType.code)
        .where('organization', '==', item));
    }),
    bindOrgFollowers: firestoreAction(({ commit, state, bindFirestoreRef }: any, item: any[]) => {
      bindFirestoreRef('orgFollowers', db.collection('users')
        .where('uid', 'in', item));
    }),
    bindOrgMembers: firestoreAction(({ commit, state, bindFirestoreRef }: any, item: any[]) => {
      bindFirestoreRef('orgMembers', db.collection('users')
        .where('uid', 'in', item));
    }),
    bindOrgModMember: firestoreAction(({ commit, state, bindFirestoreRef }: any, item: any[]) => {
      bindFirestoreRef('orgModerationMembers', db.collection('users')
        .where('uid', 'in', item));
    }),
    bindHomePagePosts: firestoreAction(({ commit, state, bindFirestoreRef }: any, item: any[]) => {
      bindFirestoreRef('homePagePosts', db.collection('posts')
        .orderBy('createdTime', 'desc')
        // .where('createdBy', 'in', item)
        // .where('type.code', '==', PostType.user.code)
        .where('access.code', '==', AccessType.publicType.code)
        .where('status.code', '==', StatusType.approved.code));
    }),
    // eslint-disable-next-line
    bindHomePageFollowerPosts: firestoreAction(({ bindFirestoreRef }: any, item: any[]) => {
      return new Promise((resolve, reject) => {
        bindFirestoreRef('homePageFollowerPosts', db.collection('posts')
          .orderBy('createdTime', 'desc')
          .where('organization', 'in', item)
          .where('access.code', '==', AccessType.publicType.code)
          .where('status.code', '==', StatusType.approved.code))
          .then((result: any) => {
            resolve(result);
          })
          .catch((err: any) => {
            reject(err);
          });
      });
    }),
    // eslint-disable-next-line
    bindHomePageOrgPosts: firestoreAction(({ bindFirestoreRef }: any, item: any[]) => {
      return new Promise((resolve, reject) => {
        bindFirestoreRef('homePageOrgPosts', db.collection('posts')
          .orderBy('createdTime', 'desc')
          .where('organization', 'in', item)
          .where('access.code', '==', AccessType.publicType.code)
          .where('status.code', '==', StatusType.approved.code))
          .then((result: any) => {
            resolve(result);
          })
          .catch((err: any) => {
            reject(err);
          });
      });
    }),
    bindReportPagePosts: firestoreAction(({ bindFirestoreRef }: any, status: StatusType) => {
      bindFirestoreRef('reportPagePosts', db.collection('posts')
        // .where('createdBy', 'in', item)
        // .orderBy('createdTime', 'desc')
        .where('status.code', '==', status.code));
    }),
    bindRejectedPosts: firestoreAction(({ bindFirestoreRef }: any, status: StatusType) => {
      bindFirestoreRef('rejectPosts', db.collection('posts')
        // .where('createdBy', 'in', item)
        // .orderBy('createdTime', 'desc')
        .where('status.code', '==', status.code));
    }),
    createUser({ state }: any, newItem: any) {
      return new Promise((resolve, reject) => {
        if (newItem.doc) {
          db.collection(newItem.collection)
            .doc(newItem.doc)
            .set(
              newItem.payload,
            )
            .then((result) => {
              resolve(result);
            })
            .catch((err) => {
              reject(err);
            });
        } else {
          db.collection(newItem.collection)
            .add(
              newItem.payload,
            )
            .then((result) => {
              resolve(result);
            })
            .catch((err) => {
              reject(err);
            });
        }
      });
    },
    sendRequests({ state }: any, item: any) {
      return new Promise((resolve, reject) => {
        db.collection(item.collection)
          .doc(item.doc.uid)
          .collection(item.sendRequests)
          .doc(item.payload.uid)
          .set(
            item.payload,
            {
              merge: true,
            },
          )
          .then((result) => {
            resolve(result);
          })
          .catch((err) => {
            reject(err);
          });
        db.collection(item.collection)
          .doc(item.payload.uid)
          .collection(item.RecivedRequests)
          .doc(item.doc.uid)
          .set(
            item.doc,
            {
              merge: true,
            },
          )
          .then((result) => {
            resolve(result);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    acceptRequests({ state }: any, item: any) {
      return new Promise((resolve, reject) => {
        db.collection(item.collection)
          .doc(item.doc.uid)
          .collection(item.acceptRequests)
          .doc(item.payload.uid)
          .set(
            item.payload,
            {
              merge: true,
            },
          )
          .then((result) => {
            resolve(result);
          })
          .catch((err) => {
            reject(err);
          });
        db.collection(item.collection)
          .doc(item.payload.uid)
          .collection(item.acceptRequests)
          .doc(item.doc.uid)
          .set(
            item.doc,
            {
              merge: true,
            },
          )
          .then((result) => {
            resolve(result);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    findUser({ state, commit }: any, newItem: any) {
      return new Promise((resolve, reject) => {
        const docRef = db.collection('users').doc(newItem.id)
          .get().then((doc: any) => {
            if (doc.exists) {
              commit('setUser', doc.data());
            } else {
              commit('setUser', '');
            }
            resolve(resolve);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    createChatRoom({ state }: any, newItem: any) {
      return new Promise((resolve, reject) => {
        db.collection(newItem.collection)
          .add(
            newItem.payload,
          )
          .then((result) => {
            resolve(result);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    updateChatRoom({ state }: any, update: any) {
      return new Promise((resolve, reject) => {
        db.collection(update.collection)
          .doc(update.payload.id)
          .set(
            update.payload,
            { merge: true },
          )
          .then((result) => {
            resolve(result);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    addToCollection({ state }: any, newItem: any) {
      return new Promise((resolve, reject) => {
        if (newItem.doc) {
          db.collection(newItem.collection)
            .doc(newItem.doc)
            .set(
              newItem.payload,
            )
            .then((result) => {
              resolve(result);
            })
            .catch((err) => {
              reject(err);
            });
        } else {
          db.collection(newItem.collection)
            .add(
              newItem.payload,
            )
            .then((result) => {
              resolve(result);
            })
            .catch((err) => {
              reject(err);
            });
        }
      });
    },
    loadRole({ state }: any, newItem: any) {
      return new Promise((resolve, reject) => {
        if (newItem.payload.roleType.code) {
          db.collection(newItem.collection)
            .doc(newItem.payload.roleType.code)
            .set(
              { ...newItem.payload },
            )
            .then((result) => {
              resolve(result);
            })
            .catch((err) => {
              reject(err);
            });
        } else {
          db.collection(newItem.collection)
            .add(
              { ...newItem.payload },
            )
            .then((result) => {
              resolve(result);
            })
            .catch((err) => {
              reject(err);
            });
        }
      });
    },
    removeFromCollection({ state }: any, item: any) {
      return new Promise((resolve, reject) => {
        db.collection(item.collection)
          .doc(item.payload)
          .delete()
          .then(() => {
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    removeFromRequests({ state }: any, item: any) {
      return new Promise((resolve, reject) => {
        db.collection(item.collection)
          .doc(item.doc)
          .collection(item.recivedRequests)
          .doc(item.payload)
          .delete()
          .then((result) => {
            resolve(result);
          })
          .catch((err) => {
            reject(err);
          });
        db.collection(item.collection)
          .doc(item.payload)
          .collection(item.sendRequests)
          .doc(item.doc)
          .delete()
          .then((result) => {
            resolve(result);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    updateCollection({ state }: any, update: any) {
      return new Promise((resolve, reject) => {
        db.collection(update.collection)
          .doc(update.doc)
          .update(
            update.payload,
          )
          .then((result) => {
            resolve(result);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    addToPosts({ state }: any, newItem: any) {
      return new Promise((resolve, reject) => {
        // const photoURLs = [] as any;
        db.collection(newItem.collection)
          .add(
            newItem.payload,
          )
          .then((data) => {
            resolve(data);
          });
      });
    },

    addToCampaignAdd({ state }: any, newItem: any) {
      return new Promise((resolve, reject) => {
        db.collection(COLLECTION_POSTS)
          .add(
            newItem.payload.post,
          )
          .then((data) => {
            db.collection(newItem.collection)
              .add(
                {
                  criteria: newItem.payload.criteria,
                  post: FirebaseUtil.ObjectToRef(COLLECTION_POSTS, data.id),
                },
              );
            if (!newItem.file) {
              return;
            }
            const ext = newItem.file.name.slice(newItem.file.name.lastIndexOf('.'));
            const profileImageRef = firebase.storage().ref().child(`${data.id}/image.${ext}`);
            profileImageRef.put(newItem.file)
              .then(() => {
                profileImageRef.getDownloadURL()
                  .then((downloadURL: any) => {
                    db.collection(COLLECTION_POSTS).doc(data.id).update({
                      photoURL: downloadURL,
                    });
                  });
              });
          });
      });
    },

    upDateProfile({ state, commit }: any, item: any) {
      return new Promise((resolve, reject) => {
        db
          .collection(item.collection)
          .doc(item.payload.uid)
          .update(
            item.payload,
          ).then((result) => {
            if (item.file) {
              const ext = item.file.name.slice(item.file.name.lastIndexOf('.'));
              const profileImageRef = firebase.storage().ref().child(`${item.payload.uid}/profile.${ext}`);
              profileImageRef.put(item.file)
                .then(() => {
                  profileImageRef.getDownloadURL()
                    .then((downloadURL: any) => {
                      state.currentUser.updateProfile({
                        displayName: item.payload.userName,
                        photoURL: downloadURL,
                      });
                      db.collection(item.collection).doc(item.payload.uid).update({
                        photoURL: downloadURL,
                      });
                    });
                });
            } else {
              state.currentUser.updateProfile({
                displayName: item.payload.userName,
              });
            }
            resolve(result);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  } as any,

  getters: {
    authenticated(state: any) {
      return !!state.currentUser;
    },
  },
});
